<template>
  <div class="product-price-graph-option-page">
    <div v-if="createOptions" class="create-container input-group col-block">
      <div :style="{ height: '10px' }"></div>
      <div class="create-title">{{ createOptions.title }}</div>
      <div :style="{ height: '5px' }"></div>
      <input type="text" :list="'graph-option-list-' + name" v-model="createData" @change="e => checkData(createData)" />
      <datalist v-if="filtedCreateOptions.length" :id="'graph-option-list-' + name">
        <option v-for="(option, index) in filtedCreateOptions" :key="index" :value="option.title"></option>
      </datalist>
      <div :style="{ height: '10px' }"></div>
      <button type="button" name="button" class="white-button" @click="e => addData()">
        <span>加入</span>
      </button>
      <div :style="{ height: '10px' }"></div>
    </div>
    <div class="check-container">
      <label class="data-block row-block" :class="{ disabled: isDisabled(data) }" v-for="(data, index) in checks" :key="index" :for="'graph-option-check-' + data.value" @click="e => !isDisabled(data) && selectData(data)">
        <!-- <input type="checkbox" v-show="false" :id="'graph-option-check-' + data.value" :value="data.value" v-model="selected"> -->
        <img :src="require('../../assets/images/checkbox-' + (selected.includes(data.value) ? 'true' : 'false') + '.svg')">
        <div :style="{ width: '8px' }"></div>
        <div class="data-title" :style="{ flex: 1 }" :title="data.title">{{ data.title.replace(/\(.+\)$/, '') }}</div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      default: () => 1
    },
    max: {
      type: Number,
      default: () => 7
    },
    countryOptions: {
      type: Array,
      default: () => ([])
    },
    createOptions: {
      type: Object,
      default: () => null
    },
    checkOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      createData: '',
      checks: [],
      selected: []
    }
  },
  computed: {
    filtedCreateOptions () {
      let createOptions = this.createOptions.options(this.createData) || []
      return createOptions
    }
  },
  created () {
    this.checks = [...(this.checkOptions.options || [])]
    this.selected = [...(this.checkOptions.values || [])]
  },
  watch: {
    'checkOptions' () {
      this.checks = [...(this.checkOptions.options || [])]
      this.selected = [...(this.checkOptions.values || [])]
    }
  },
  methods: {
    isDisabled (data) {
      return (this.selected.length <= this.min && this.selected.includes(data.value)) || (this.selected.length >= this.max && !this.selected.includes(data.value))
    },
    checkData (value) {
      let checker = this.createOptions.checkData || (() => true)
      if (value && !checker(value)) {
        this.createData = ''
      }
    },
    addData () {
      this.$emit('create', this.createData)
      this.selectData(this.countryOptions.find(option => option.title === this.createData) || { title: '無', value: '無', country: { iso_name: '', chinese_name: '' } })
      this.createData = ''
    },
    selectData (data) {
      let selected = [...this.selected]
      if (selected.includes(data.value)) {
        selected.splice(selected.indexOf(data.value), 1)
        if (this.createOptions) {
          this.$emit('remove', data.title)
        }
      } else {
        selected.push(data.value)
      }
      this.$emit('select', selected)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/productPrice/graphOptions.vue